import React from 'react';
import { UpdateSoftware } from 'src/js/pages/settings/upgrade/update-software';

export const UpgradeUploadCompletedTest: React.FunctionComponent = () => (
  <UpdateSoftware
    data={{ currentVersion: '1.2.0-55', packageToBeInstalled: 'makitox4_eec_v1.3.0-25.hai' }}
  ></UpdateSoftware>
);
